<div class="table-container">
  @if (csvDownloadEnabled && data !== undefined && data.length > 0) {
    <div class="table-actions">
      <button mat-button (click)="downloadCsv()" class="download-csv-button">
        <mat-icon>download</mat-icon>
        {{ 'ADMIN.EXPORT_CSV' | translate }}
      </button>
      @if (fullData !== null && fullData.length > 0) {
        <button (click)="downloadFullCsv()" class="button-export">
          <mat-icon class="icon">download</mat-icon>
          {{ 'ADMIN.EXPORT_TABLE' | translate }}
        </button>
      }
    </div>
  }
  <div class="table-scroll-container">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="mat-table mat-elevation-z8"
      [class.sticky-actions-column]="stickyActionsColumn"
      (matSortChange)="handleSortEvent($event)"
    >
      @if (selectable) {
        <ng-container matColumnDef="select" [sticky]="true">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleAll()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="isSelected(element)" (change)="toggleRow(element)"></mat-checkbox>
          </td>
          @if (displayFooterRow) {
            <td mat-footer-cell *matFooterCellDef></td>
          }
        </ng-container>
      }
      @for (column of columns; track $index) {
        <ng-container [matColumnDef]="column.columnDef" [sticky]="column.sticky">
          @if (column.sortable) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ getHeader(column) | translate }}
            </th>
          } @else {
            <th mat-header-cell *matHeaderCellDef [class.highlighted]="column.highlight">
              {{ getHeader(column) | translate }}
            </th>
          }
          <td mat-cell *matCellDef="let element" [class.highlighted]="column.highlight">
            <app-paginated-table-cell [data]="column.cell(element)" [columnType]="column.type" [timezone]="timezone"></app-paginated-table-cell>
          </td>
          @if (displayFooterRow) {
            <td mat-footer-cell *matFooterCellDef [class.highlighted]="column.highlight">
              @let footerValue = getFooterValue(column);
              @if (footerValue !== null) {
                <app-paginated-table-cell [data]="footerValue" [columnType]="column.footerType ?? column.type" [timezone]="timezone"></app-paginated-table-cell>
              }
            </td>
          }
        </ng-container>
      }
      @if (displayActionsColumn) {
        <ng-container matColumnDef="actions" [stickyEnd]="stickyActionsColumn">
          <th mat-header-cell *matHeaderCellDef>{{ 'COMMON.ACTIONS' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="buttons">
            @if (generateEditLink !== null) {
              <a [routerLink]="generateEditLink(element)" queryParamsHandling="merge">
                <button mat-icon-button>
                  <mat-icon>edit</mat-icon>
                </button>
              </a>
            }
            @for (action of actions; track $index) {
              @if (action.isVisible === undefined || action.isVisible(element)) {
                <span class="action" [matTooltip]="actionTooltipKey(action, element) | translate" [matTooltipDisabled]="!showsActionTooltip(action, element)">
                  @if (action.icon) {
                    <button mat-icon-button (click)="action.handle(element)" [disabled]="isActionDisabled(action, element)">
                      <mat-icon>{{ action.icon }}</mat-icon>
                    </button>
                  } @else {
                    <button mat-button (click)="action.handle(element)" [disabled]="isActionDisabled(action, element)">
                      {{ action.translationKey | translate }}
                    </button>
                  }
                </span>
              }
            }
          </td>
          @if (displayFooterRow) {
            <td mat-footer-cell *matFooterCellDef></td>
          }
        </ng-container>
      }
      <tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="getRowClass(row)"></tr>
      @if (displayFooterRow) {
        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
      }
    </table>
  </div>
  @if (paginationEnabled) {
    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
    >
    </mat-paginator>
  }
</div>
